import React, { Component } from "react"
import { NavLink } from "react-router-dom"
import classnames from "classnames"

class SidebarHeader extends Component {
  render() {
    let {
      collapsed,
      menuShadow
    } = this.props
    return (
      <div className="navbar-header" style={{height: collapsed === false ? '100px' : '5rem'}}>
        <ul className="nav navbar-nav flex-row">
          <li className="nav-item mr-auto">
            <NavLink to="/" className="navbar-brand">
              {collapsed === false ? <div className="brand-logo-big" /> : <div>
                <div className="brand-logo" />
                <h2 className="brand-text mb-0">Cloakit.pro</h2>
              </div>}
            </NavLink>
          </li>
        </ul>
        <div
          className={classnames("shadow-bottom", {
            "d-none": menuShadow === false
          })}
        />
      </div>
    )
  }
}

export default SidebarHeader
